import { useQuery, UseQueryResult } from 'react-query';

import { twilioInfoFetch } from '../utils/urls';

import { getTokenWithType } from './useAuth';
import { ErrorModal } from 'types/modalTypes';

async function fetchTwilioDetails(accountId: number): Promise<any> {
  if (accountId) {
    const response = await fetch(twilioInfoFetch(accountId), {
      method: 'GET',
      headers: {
        Authorization: getTokenWithType(),
      },
    });
    return response.json();
  }
}

type TError = ErrorModal;

function useGetTwilioInfo(accountId: number): UseQueryResult<any, TError> {
  return useQuery(
    ['get_twilio_info', accountId],
    async () => {
      const result = await fetchTwilioDetails(accountId);
      const twilioData = {
        TwilioBranchOutConditionsId:
          result?.Data?.TwilioAccountBranchOutCondition
            ?.TwilioBranchOutConditionsId,
        TwilioWorkFlowId: result?.Data?.TwilioAccountWorkFlow?.TwilioWorkFlowId,
        TwilioContactNumbers: result?.Data?.TwilioContactNumbers?.map(
          (item: any) => ({
            PhoneTypeId: item?.TwilioContactNumberPhoneTypeId,
            CountryId: item?.CountryId,
            PhoneNumber: item?.PhoneNumber,
            Id: item?.Id,
            Name: item?.Name,
          }),
        ),
        EnableRecording: result?.Data?.EnableRecording,
        TwilioFlexPriority: result?.Data?.TwilioFlexPriority,
        TwilioPAK: result?.Data?.TwilioPAK,
        RouteToAccountId: result?.Data?.RouteToAccountId,
      };

      return twilioData;
    },

    {
      staleTime: 60 * 1000,
      refetchOnWindowFocus: true,
      enabled: accountId !== undefined || accountId !== null,
    },
  );
}

export { useGetTwilioInfo };
